import { dayFormat } from '../../week'

export const apiEndPoint = ({ service_id, service_type, start_date, record }) =>
  `/api/${service_type}/${service_id}/session-summaries/${dayFormat(start_date)}/${record.child_id}`



// WEBPACK FOOTER //
// ./src/session-summaries/details/helpers.js